<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/configuration")
            i.fa.fa-cogs
            span.ml-1 {{ $t("ui.configuration") }}
        b-breadcrumb-item
          router-link(to="/configuration/sport")
            i.fa.fa-basketball-ball
            span.ml-1 {{ $tc("ui.sports", 2) }}
    div.row.mb-5
      div.col-md-12
        div.card
          div.card-header
            div.row
              div.col-md-12.mb-1
                div.form-row
                  div.col-sm-9.col-md-6.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.icon-magnifier
                      DebounceInput(required autofocus type="text" v-model="sportSearch" :placeholder="$t('message.search_by_id_name')")
                  div.col-sm-3.col-md-1.mb-1
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="id") {{ $t("ui.id") }}
                      b-form-radio(value="name") {{ $t("ui.name") }}
          div.card-body.p-1.clusterize
            .clusterize-scroll
              table.tablex(style="width: auto;" v-columns-resizable)
                thead
                  tr
                    th.sticky-position
                      span {{ $t('ui.id') }}
                    th.sticky-position
                      span {{ $t("ui.name") }}
                    th.text-center.sticky-position(width=100)
                      span {{ $t("ui.affect_value") }}
                tbody.clusterize-content
                  tr(v-for="(item, index) in filteredSportList")
                    td
                      span {{ item.sport_id }}
                    td
                      span {{ item.sport_type }}
                    td
                      select(@change="changedAffectValue(item, $event)" :value="getDecimal(item.affect_value)")
                        option(v-for="affValueInfo in affValueList" v-bind:value="affValueInfo.value")
                          | {{ affValueInfo.text }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    DebounceInput
  },
  data() {
    return {
      filterBy: "id",
      sportList: [],
      sportSearch: "",
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      affValueList: []
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    filteredSportList() {
      return this.sportList.filter(item => {
        if (this.filterBy == "name") {
          return item.sport_type.toLowerCase().indexOf(this.sportSearch.toLowerCase()) > -1;
        } else {
          return item.sport_id.toString().indexOf(this.sportSearch.toLowerCase()) > -1;
        }
      });
    }
  },
  mounted: function() {
    this.getSportList();
    this.getAffectValueList();
  },
  methods: {
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.sport
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list.filter(item => { return item.sport_id > 0; });
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getAffectValueList: function() {
      for (var i = 0.0; i <= 1.0; i += 0.1) {
        this.affValueList.push({
          value: parseFloat(i).toFixed(2),
          text: i.toFixed(2)
        });
      }
    },
    getDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
    changedAffectValue: function(affValue, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.affect_value"),
          text: this.$t("message.change_affect_value_confirm", { name: affValue.sport_type }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmAffectValue(affValue, eventStatus.srcElement.value);
          } else {
            eventStatus.srcElement.value = parseFloat(affValue.affect_value).toFixed(2);
          }
        });
    },
    confirmAffectValue: function(affValue, value) {
      let url = config.updateSportAffectValueUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.sport,
        sport_id: affValue.sport_id,
        affect_value: value
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                affValue.affect_value = value;
                this.$snotify.success(this.$t("message.success"));
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
